<template>

  <hit_login>

    <hit_dashboard v-if="user">

      <div >

  
        <vote_conflict v-if="user" :data="{user: user, board:board, ID: ID}" :settings="{no_delete: true, no_container: true}"/>

        <div class="hit-panel-body hit-text-center">



          <router-link :to="{name: 'feedbacks', params: $route.params}" class="hit-btn hit-btn-default hit-btn-block" >{{ $tc("message.back") }}</router-link>
        </div>
      </div>

    </hit_dashboard>

  </hit_login>
</template>

<script>

import feedback_delete from '@core/components/content/app/feedback/feedback_delete'
import vote_conflict from '@core/components/content/app/vote_conflict'
import md5 from 'js-md5'

export default{

  components: {feedback_delete, vote_conflict},
  extends: vote_conflict,
  props: {details: Object, callback: Function},

  mounted () {
    this.$store.commit('get_session_user')

    this.user = this.$store.getters.user.md5_id
    this.board = this.$route.params.boardID
    this.ID = this.$route.params.entryID

    this.get_entry()
  }
}

</script>
